export default {
  SEARCH_CLEARED: 'shelf.clear-search',
  SEARCH_SELECTED: 'shelf.search-selected',
  OMNI_FILTER_SELECTED: 'shelf.omni-filter-selected',
  OMNI_FILTER_CLEARED: 'shelf.omni-filter-cleared',
  FAVOURITED: 'shelf.favourited',
  LOGGED_OUT_FAVOURITED: 'shelf.logged-out-favourited',
};
